// src/hooks/useUser.js
import { useEffect, useState } from "react";

export const useUser = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const checkAuth = async () => {
      try {
        const res = await fetch("/.auth/me", {
          credentials: "same-origin",
          cache: "no-store",
        });

        if (!res.ok) {
          throw new Error(`Auth check failed with status ${res.status}`);
        }

        const json = await res.json();
        const clientPrincipal = json?.clientPrincipal ?? null;

        if (isMounted) {
          setUser(clientPrincipal);
        }
      } catch (err) {
        console.error("Failed to fetch user info", err);
        if (isMounted) {
          setUser(null);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    checkAuth();

    return () => {
      isMounted = false;
    };
  }, []);

  const userEmail = user?.userDetails ?? null;
  const userRoles = Array.isArray(user?.userRoles) ? user.userRoles : [];

  return {
    user,
    loading,
    userLoading: loading,
    userEmail,
    userRoles,
  };
};